import { HtmlTable } from '../../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import styled from '../../../../../theme/theme';

export const StyledHtmlTable = styled(HtmlTable)<{ isEmbeddedMobile: boolean }>(
  ({ theme, isEmbeddedMobile }) => ({
    'td, th': {
      display: 'none',
      '&:nth-child(1), &:nth-last-child(1)': {
        display: 'table-cell',
      },
    },
    [`@media only screen and (min-width: ${isEmbeddedMobile ? theme.breakpoints[0] : 0})`]: {
      'td, th': {
        display: 'table-cell',
      },
    },
  }),
);
